module.exports = __webpack_public_path__ + "img/OlympicParis.ca92e72d.jpg";